<template>
  <footer class="public-footer">
    <div class="public-footer-content">
      <a
        v-for="logo in logos"
        :key="logo.href"
        :href="logo.href"
        target="_blank"
        rel="noopener noreferrer"
      >
        <v-avatar tile size="66" class="my-4 mr-4">
          <v-img :src="logo.src" :alt="logo.alt" />
        </v-avatar>
      </a>
      <p class="credits pt-4">
        SACI | UFPB | {{ footerReference }} |
        <a
          class="credits"
          href="https://forms.gle/G1zUrtJriExafCDs8"
          target="_blank"
          rel="noopener noreferrer"
        >
          Relatar um problema
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PublicFooter",
  props: {
    period: String,
    year: [String, Number]
  },
  data() {
    return {
      logos: [
        {
          href: "https://www.ufpb.br/",
          src: require("@/assets/ufpb.png"),
          alt: "UFPB"
        },
        {
          href: "http://laser.ci.ufpb.br/",
          src: require("@/assets/laser.png"),
          alt: "LASER"
        },
        {
          href: "https://linktr.ee/log.ufpb",
          src: require("@/assets/log.png"),
          alt: "LOG"
        },
        {
          href: "https://ci.ufpb.br/",
          src: require("@/assets/ci.jpeg"),
          alt: "Centro de Informática"
        }
      ]
    };
  },
  computed: {
    footerReference() {
      if (this.period) return `Período ${this.period}`;
      return this.year || new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.public-footer {
  bottom: 0;
  text-align: center;
  z-index: 4;
}

.public-footer-content {
  max-width: 1920px;
  margin: 0 auto;
}

.credits {
  color: #7a7a7a;
  font-size: 14px;
  margin-bottom: 0;
}
</style>
